import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, text } from '../../../core/styles/theme/default';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';

const StyledLink = styled(LinkContent)(
  () => css`
    ${text.c1};
    color: ${colors.primary};
    text-decoration: underline;

    &:hover,
    &:focus {
      text-decoration: none;

      .label::after {
        border-bottom: none;
      }
    }
  `,
);

const LinkInternal = (props: LinkProps) => {
  const linkProps = {
    ...props,
    className: props.className ? `${props.className} animate` : 'animate',
  };

  return <StyledLink iconAfter="AnimatedIconArrowRight" {...linkProps} />;
};

export default LinkInternal;
